module.exports = __webpack_public_path__ + "assets/img/ac.1468abca.png";